export const types = {
  RESET_CONNECTIONS: 'RESET_CONNECTIONS',
  LOAD_AUTH_CONNECTIONS_SUCCESS: 'LOAD_AUTH_CONNECTIONS_SUCCESS',
  NO_CONNECTION_FOUND: 'NO_CONNECTION_FOUND',
  LOADING_AUTH_CONNECTION: 'LOADING_AUTH_CONNECTION'
};
